import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-4/5 bg-white rounded-md mt-4 mx-auto h-screen mb-12" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "User", -1)
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GraphList = _resolveComponent("GraphList")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.user)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", null, _toDisplayString(_ctx.user.nickname), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.user.profile), 1),
            _createElementVNode("div", null, [
              _createVNode(_component_GraphList, { user_id: _ctx.user_id }, null, 8, ["user_id"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}